import { RouteObject } from '@rocketlane/rocket-router';
import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';

export const marketplaceWidgetRoutes: RouteObject = {
  path: 'marketplace',
  children: [
    {
      path: 'apps/:appId/versions/:versionId/widgets/:widgetIdentifier',
      async lazy() {
        const { MarketplaceWidgetRoute } =
          await retryImportInsideRoutesDefinition(() => import('./widgets'));

        return {
          element: <MarketplaceWidgetRoute />,
        };
      },
    },
  ],
};

export const ldsRoutes: RouteObject = {
  path: 'lds',
  children: [
    {
      path: ':widgetIdentifier',
      async lazy() {
        const { LdsWidgetRoute } = await retryImportInsideRoutesDefinition(
          () => import('./lds-widgets'),
        );

        return {
          element: <LdsWidgetRoute />,
        };
      },
    },
  ],
};
